var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponbg01S(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 137,
    viewBox: "0 0 160 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "g6jn9f76ya"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 10214",
    width: 160,
    height: 137,
    rx: 5,
    style: {
      fill: "#f15e5e"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 10210",
    width: 160,
    height: 137,
    rx: 5,
    style: {
      fill: "#f15e5e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 1123",
    style: {
      opacity: 0.5,
      clipPath: "url(#g6jn9f76ya)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 11552"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10694"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10689"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42385",
    d: "M1184.694 252.294a1.706 1.706 0 0 0-.206.012 1.277 1.277 0 0 0-.733.315.564.564 0 0 0-.183.567 1.11 1.11 0 0 0 1.119.622 1.734 1.734 0 0 0 .206-.013 1.279 1.279 0 0 0 .734-.315.564.564 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-880.214 -209.487)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42386",
    d: "M1184.694 283.72a1.7 1.7 0 0 0-.206.012 1.277 1.277 0 0 0-.733.315.563.563 0 0 0-.183.567 1.11 1.11 0 0 0 1.119.622 1.734 1.734 0 0 0 .206-.013 1.279 1.279 0 0 0 .734-.315.564.564 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-880.214 -237.99)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42387",
    d: "M1184.694 315.146a1.709 1.709 0 0 0-.206.012 1.277 1.277 0 0 0-.733.315.564.564 0 0 0-.183.567 1.11 1.11 0 0 0 1.119.622 1.734 1.734 0 0 0 .206-.013 1.279 1.279 0 0 0 .734-.315.564.564 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-880.214 -266.493)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42388",
    d: "M1184.694 346.572a1.7 1.7 0 0 0-.206.012 1.277 1.277 0 0 0-.733.315.564.564 0 0 0-.183.567 1.11 1.11 0 0 0 1.119.622 1.734 1.734 0 0 0 .206-.013 1.279 1.279 0 0 0 .734-.315.564.564 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-880.214 -294.996)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42389",
    d: "M1184.694 378a1.709 1.709 0 0 0-.206.012 1.277 1.277 0 0 0-.733.315.564.564 0 0 0-.183.567 1.11 1.11 0 0 0 1.119.622 1.74 1.74 0 0 0 .206-.013 1.279 1.279 0 0 0 .734-.315.564.564 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-880.214 -323.5)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42390",
    d: "M1153.263 252.294a1.713 1.713 0 0 0-.206.012 1.275 1.275 0 0 0-.732.315.564.564 0 0 0-.184.567 1.111 1.111 0 0 0 1.119.622 1.725 1.725 0 0 0 .206-.013 1.279 1.279 0 0 0 .734-.315.562.562 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-853.178 -209.487)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42391",
    d: "M1121.833 252.294a1.707 1.707 0 0 0-.206.012 1.277 1.277 0 0 0-.733.315.563.563 0 0 0-.183.567 1.11 1.11 0 0 0 1.119.622 1.735 1.735 0 0 0 .206-.013 1.279 1.279 0 0 0 .733-.315.563.563 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-826.142 -209.487)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42392",
    d: "M1090.4 252.294a1.713 1.713 0 0 0-.206.012 1.276 1.276 0 0 0-.732.315.563.563 0 0 0-.184.567 1.11 1.11 0 0 0 1.119.622 1.726 1.726 0 0 0 .206-.013 1.277 1.277 0 0 0 .733-.315.562.562 0 0 0 .183-.566 1.11 1.11 0 0 0-1.12-.622",
    transform: "translate(-799.105 -209.487)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42393",
    d: "M1058.971 252.294a1.711 1.711 0 0 0-.206.012 1.276 1.276 0 0 0-.732.315.564.564 0 0 0-.184.567 1.111 1.111 0 0 0 1.12.622 1.724 1.724 0 0 0 .206-.013 1.28 1.28 0 0 0 .734-.315.563.563 0 0 0 .182-.566 1.11 1.11 0 0 0-1.119-.622",
    transform: "translate(-772.068 -209.487)",
    style: {
      fill: "#e63737"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42394",
    d: "M1099.156 441.342a6.387 6.387 0 0 1-6.543 0 2.425 2.425 0 0 1 0-4.353 6.387 6.387 0 0 1 6.543 0 2.425 2.425 0 0 1 0 4.353",
    transform: "translate(-808.45 -362.929)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42395",
    d: "m648.474 74.494-11.511 28.58 42.96-7.658z",
    transform: "translate(-536.357 -61.506)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42396",
    d: "M619.509 28.58 631.02 0l31.449 20.922zM631.465 1.1l-10.741 26.671 40.085-7.145z",
    transform: "translate(-522.25 3.486)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10690"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42397",
    d: "M1019.309 656.472a1.425 1.425 0 0 0 .194.108 1.96 1.96 0 0 0 1.042.149 1.562 1.562 0 0 0 .9-.385.713.713 0 0 0-.16-1.182 1.448 1.448 0 0 0-.194-.108 1.963 1.963 0 0 0-1.044-.149 1.559 1.559 0 0 0-.894.385.713.713 0 0 0 .16 1.182",
    transform: "translate(-757.495 -541.317)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42398",
    d: "M1019.6 699.854a1.4 1.4 0 0 0 .194.108 1.963 1.963 0 0 0 1.042.149 1.561 1.561 0 0 0 .9-.385.713.713 0 0 0-.159-1.182 1.472 1.472 0 0 0-.194-.108 1.966 1.966 0 0 0-1.044-.149 1.558 1.558 0 0 0-.894.385.713.713 0 0 0 .16 1.182",
    transform: "translate(-757.708 -577.074)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42399",
    d: "M1041.145 678.308a1.469 1.469 0 0 0 .194.108 1.963 1.963 0 0 0 1.043.149 1.562 1.562 0 0 0 .9-.385.713.713 0 0 0-.159-1.182 1.47 1.47 0 0 0-.194-.108 1.964 1.964 0 0 0-1.044-.149 1.558 1.558 0 0 0-.894.385.713.713 0 0 0 .159 1.182",
    transform: "translate(-773.561 -559.315)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42400",
    d: "M1062.691 656.762a1.41 1.41 0 0 0 .194.108 1.962 1.962 0 0 0 1.043.149 1.561 1.561 0 0 0 .9-.385.713.713 0 0 0-.159-1.182 1.451 1.451 0 0 0-.194-.108 1.963 1.963 0 0 0-1.044-.149 1.559 1.559 0 0 0-.894.385.713.713 0 0 0 .16 1.182",
    transform: "translate(-789.414 -541.556)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42401",
    d: "M1041 656.617a1.449 1.449 0 0 0 .194.108 1.962 1.962 0 0 0 1.042.149 1.564 1.564 0 0 0 .9-.385.713.713 0 0 0-.16-1.182 1.408 1.408 0 0 0-.195-.108 1.96 1.96 0 0 0-1.044-.149 1.557 1.557 0 0 0-.894.385.713.713 0 0 0 .16 1.182",
    transform: "translate(-773.454 -541.437)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42402",
    d: "M1062.98 700.144a1.418 1.418 0 0 0 .194.108 1.96 1.96 0 0 0 1.042.149 1.562 1.562 0 0 0 .9-.385.713.713 0 0 0-.16-1.182 1.443 1.443 0 0 0-.194-.108 1.966 1.966 0 0 0-1.044-.149 1.558 1.558 0 0 0-.894.385.713.713 0 0 0 .16 1.182",
    transform: "translate(-789.627 -577.313)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42403",
    d: "M1041.29 700a1.476 1.476 0 0 0 .193.108 1.964 1.964 0 0 0 1.043.149 1.564 1.564 0 0 0 .9-.385.714.714 0 0 0-.16-1.182 1.453 1.453 0 0 0-.195-.108 1.963 1.963 0 0 0-1.044-.149 1.559 1.559 0 0 0-.894.385.713.713 0 0 0 .16 1.182",
    transform: "translate(-773.668 -577.193)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42404",
    d: "M1084.527 678.6a1.428 1.428 0 0 0 .194.108 1.96 1.96 0 0 0 1.042.149 1.564 1.564 0 0 0 .9-.385.713.713 0 0 0-.16-1.182 1.433 1.433 0 0 0-.194-.108 1.965 1.965 0 0 0-1.044-.149 1.556 1.556 0 0 0-.894.385.713.713 0 0 0 .159 1.182",
    transform: "translate(-805.481 -559.554)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42405",
    d: "M1062.836 678.453a1.452 1.452 0 0 0 .194.108 1.96 1.96 0 0 0 1.042.149 1.564 1.564 0 0 0 .9-.385.713.713 0 0 0-.16-1.182 1.459 1.459 0 0 0-.195-.108 1.962 1.962 0 0 0-1.043-.149 1.557 1.557 0 0 0-.894.385.713.713 0 0 0 .159 1.182",
    transform: "translate(-789.522 -559.435)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42406",
    d: "M1084.382 656.908a1.482 1.482 0 0 0 .194.107 1.961 1.961 0 0 0 1.042.149 1.561 1.561 0 0 0 .9-.385.713.713 0 0 0-.159-1.182 1.444 1.444 0 0 0-.194-.107 1.966 1.966 0 0 0-1.044-.15 1.557 1.557 0 0 0-.894.385.713.713 0 0 0 .159 1.182",
    transform: "translate(-805.375 -541.677)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42407",
    d: "M1084.672 700.289a1.451 1.451 0 0 0 .193.108 1.963 1.963 0 0 0 1.043.149 1.562 1.562 0 0 0 .9-.385.713.713 0 0 0-.159-1.182 1.452 1.452 0 0 0-.194-.108 1.964 1.964 0 0 0-1.044-.149 1.559 1.559 0 0 0-.894.385.713.713 0 0 0 .16 1.182",
    transform: "translate(-805.588 -577.432)",
    style: {
      fill: "#e63737"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10691"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42408",
    d: "M448.636 572.157a3.069 3.069 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.1 3.1 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-362.124 -465.764)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42409",
    d: "M481.606 539.626a3.058 3.058 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.015 1.015 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.116 3.116 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-389.091 -437.174)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42410",
    d: "M382.7 572.157a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.015 1.015 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.1 3.1 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-308.192 -465.764)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42411",
    d: "M415.667 539.626a3.059 3.059 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.115 3.115 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-335.158 -437.174)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42412",
    d: "M382.7 637.219a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.112 3.112 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-308.192 -522.945)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42413",
    d: "M415.667 604.688a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.115 3.115 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-335.158 -494.355)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42414",
    d: "M316.759 572.157a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.1 3.1 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-254.26 -465.764)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42415",
    d: "M349.728 539.626a3.059 3.059 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.114 3.114 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-281.225 -437.174)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42416",
    d: "M316.759 637.219a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.114 3.114 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-254.26 -522.945)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42417",
    d: "M349.728 604.688a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.114 3.114 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-281.225 -494.355)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42418",
    d: "M316.759 702.28a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.127 3.127 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-254.26 -580.125)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42419",
    d: "M349.728 669.75a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.127 3.127 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-281.225 -551.536)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42420",
    d: "M250.82 637.219a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.113 3.113 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-200.326 -522.945)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42421",
    d: "M283.789 604.688a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.111 3.111 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-227.293 -494.355)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42422",
    d: "M250.82 702.28a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.126 3.126 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-200.326 -580.125)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42423",
    d: "M283.789 669.75a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.124 3.124 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-227.293 -551.536)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42424",
    d: "M283.789 734.811a3.1 3.1 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.137 3.137 0 0 0 .37-.022 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-227.293 -608.715)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42425",
    d: "M184.881 572.157a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.1 3.1 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-146.394 -465.764)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42426",
    d: "M184.881 637.219a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.112 3.112 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-146.394 -522.945)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42427",
    d: "M217.85 604.688a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.113 3.113 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-173.36 -494.355)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42428",
    d: "M184.881 702.28a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.125 3.125 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-146.394 -580.125)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42429",
    d: "M217.85 669.75a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.126 3.126 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-173.36 -551.536)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42430",
    d: "M217.85 734.811a3.1 3.1 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.139 3.139 0 0 0 .37-.022 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .329-1.019 2 2 0 0 0-2.015-1.119",
    transform: "translate(-173.36 -608.715)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42431",
    d: "M118.942 572.157a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.1 3.1 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-92.461 -465.764)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42432",
    d: "M118.942 637.219a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.113 3.113 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-92.461 -522.945)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42433",
    d: "M151.912 604.688a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.113 3.113 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-119.428 -494.355)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42434",
    d: "M118.942 702.28a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.126 3.126 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-92.461 -580.125)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42435",
    d: "M151.912 669.75a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.126 3.126 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.011 1.011 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-119.428 -551.536)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42436",
    d: "M53 637.219a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.018 1.12 3.113 3.113 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019A2 2 0 0 0 53 637.219",
    transform: "translate(-38.529 -522.945)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42437",
    d: "M85.973 604.688a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.114 3.114 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-65.496 -494.355)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42438",
    d: "M53 702.28a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.018 1.12 3.126 3.126 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019A2 2 0 0 0 53 702.28",
    transform: "translate(-38.529 -580.125)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42439",
    d: "M85.973 669.75a3.07 3.07 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.126 3.126 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-65.496 -551.536)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42440",
    d: "M85.973 734.811a3.1 3.1 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.139 3.139 0 0 0 .37-.022 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-65.496 -608.715)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42441",
    d: "M20.034 669.75a3.071 3.071 0 0 0-.37.022 2.3 2.3 0 0 0-1.318.566 1.014 1.014 0 0 0-.33 1.02 2 2 0 0 0 2.014 1.119 3.125 3.125 0 0 0 .37-.023 2.3 2.3 0 0 0 1.32-.567 1.012 1.012 0 0 0 .328-1.019 2 2 0 0 0-2.014-1.119",
    transform: "translate(-11.562 -551.536)",
    style: {
      fill: "#e63737"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42442",
    d: "m952.092 410.877-17.2-11.441 17.2-11.436 17.2 11.441zm-16.2-11.441 16.2 10.775 16.2-10.775-16.2-10.775z",
    transform: "translate(-676.318 -319.794)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42443",
    d: "M15.406 128.058a1.309 1.309 0 0 0-1.341 0l-1.819 1.21v1.784l3.16-2.1a.5.5 0 0 0 0-.892",
    transform: "translate(-16.81 -106.936)",
    style: {
      fill: "#4d4dbf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10692"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42444",
    d: "M20.216 154.206a1.035 1.035 0 0 0-1.061 0l-6.909 4.6v1.411l7.97-5.3a.393.393 0 0 0 0-.706",
    transform: "translate(-13.891 -131.532)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42445",
    d: "M25.688 180.392a1.035 1.035 0 0 0-1.061 0l-12.38 8.236v1.411l13.441-8.939a.393.393 0 0 0 0-.706",
    transform: "translate(-13.892 -154.079)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42446",
    d: "M31.158 206.577a1.035 1.035 0 0 0-1.061 0l-17.851 11.875v1.411l18.912-12.581a.393.393 0 0 0 0-.706",
    transform: "translate(-13.891 -176.624)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42447",
    d: "M36.629 232.763a1.035 1.035 0 0 0-1.061 0l-23.322 15.515v1.411l24.383-16.221a.393.393 0 0 0 0-.706",
    transform: "translate(-13.891 -199.17)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42448",
    d: "M42.1 258.949a1.035 1.035 0 0 0-1.061 0L12.247 278.1v1.411L42.1 259.654a.393.393 0 0 0 0-.706",
    transform: "translate(-13.892 -221.717)",
    style: {
      fill: "#e63737"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10693"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42449",
    d: "M1031.537 62.654h-2.058l18.731 12.461a1 1 0 0 0 1.029 0 .381.381 0 0 0 0-.684z",
    transform: "translate(-805.409 -43.306)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42450",
    d: "M1071.718 62.654h-2.058l13.423 8.93a1.005 1.005 0 0 0 1.03 0 .382.382 0 0 0 0-.684z",
    transform: "translate(-834.974 -43.306)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42451",
    d: "M1111.9 62.654h-2.058l8.115 5.4a1 1 0 0 0 1.029 0 .381.381 0 0 0 0-.684z",
    transform: "translate(-864.539 -43.306)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42452",
    d: "m1153.858 63.837-1.778-1.183h-2.058l2.807 1.867a1 1 0 0 0 1.029 0 .381.381 0 0 0 0-.684",
    transform: "translate(-894.103 -43.306)",
    style: {
      fill: "#e63737"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42453",
    d: "M1279.059 570.607c0 12.488-15.218 22.612-33.989 22.612s-33.989-10.124-33.989-22.612 15.217-22.612 33.989-22.612 33.989 10.124 33.989 22.612",
    transform: "translate(-898.898 -453.211)",
    style: {
      fill: "#e63737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 42454",
    d: "M1402.789 583.974a.674.674 0 0 1-.549-.233c-.14-.2-.007-.44.3-.533 14.235-4.368 23.433-13.927 23.433-24.351s-9.2-19.983-23.433-24.351c-.3-.093-.436-.332-.3-.533a.756.756 0 0 1 .8-.2 41.24 41.24 0 0 1 17.41 10.008c4.4 4.483 6.725 9.695 6.725 15.072s-2.326 10.589-6.725 15.072a41.243 41.243 0 0 1-17.41 10.008.863.863 0 0 1-.252.037",
    transform: "translate(-1039.509 -441.461)",
    style: {
      fill: "#e63737"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponbg01S);
export default __webpack_public_path__ + "static/media/couponbg01_s.a2accbcda930fcbba990d6e13ec97231.svg";
export { ForwardRef as ReactComponent };